<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-8">
      <div class="flmid relative">
        <div class="input-group flgrow">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearchByService' | translate }}"
            [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
              <em class="fa fa-search font17"></em>
            </button>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button type="button" class="btn btn-primary px-2-5" (click)="onSearch()" aria-label="Center Align">
            <em class="fa fa-search-plus" aria-hidden="true"></em>
          </button>
          <div class="searchbox card fix lt" *ngIf="isAdvanceSearch">
            <div class="form-row mb-3">
              <div class="col">
                <label for="name" translate>lblSerivceName </label>
                <div class='lbl-info'>
                  <input type="text" id="template-name" name="name" placeholder="{{ 'lblEnterValue' | translate }}"
                    [(ngModel)]="servicesService.serviceListRequest.name" class="form-control">
                </div>
              </div>
              <div class="col">
                <label for="serviceNo"><span translate>lblServiceNo</span></label>
                <div class="lbl-info">
                  <input id="template-serviceNo" name="serviceNo"
                    [(ngModel)]="servicesService.serviceListRequest.serviceNo"
                    placeholder="{{ 'lblEnterValue' | translate }}" class="form-control">
                </div>
              </div>
              <div class="col">
                <label for="serviceCategoryName"><span translate>lblCategoryName</span></label>
                <div class="lbl-info">
                  <input id="template-serviceCategoryName" name="serviceCategoryName"
                    [(ngModel)]="servicesService.serviceListRequest.serviceCategoryName"
                    placeholder="{{ 'lblEnterValue' | translate }}" class="form-control">
                </div>
              </div>
            </div>
            <div class="mb-3"></div>
            <div class="row">
              <div class='col-4'>
                <label for="competenceName"><span translate>lblCompetenceName</span></label>
                <div class="lbl-info">
                  <input id="template-competenceName" name="competenceName"
                    [(ngModel)]="servicesService.serviceListRequest.competenceName"
                    placeholder="{{ 'lblEnterValue' | translate }}" class="form-control mb-2">
                </div>
              </div>
              <div class='col-4'>
                <label for="status"><span translate>lblStatus</span></label>
                <div class="lbl-info">
                  <ng-select placeholder="{{ 'lblSelectStatus' | translate }}" [(ngModel)]="selectedStatus"
                    (change)="showActiveInactive($event)">
                    <ng-option *ngFor="let status of StatusList" [value]="status.id">
                      {{status.value}}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="col-4" *ngIf="isDmsSyncService">
                <label for="source"><span translate>lblSource</span></label>
                <ng-select placeholder="{{ 'lblSource' | translate }}" [(ngModel)]="sourceName" (change)="SourceChange($event)">
                  <ng-option *ngFor="let source of applicationSourceList" [value]="source.sourceId">
                    {{source.sourceName}}
                  </ng-option>
                </ng-select>
              </div>
            
              <div class="row">
                <div class="col-12">
                <label for="customCheck1" translate>lblNeedAttention</label>
                <div class="form-check pl-0">
                  <input type="checkbox" [checked]="needAttention" id="customCheck1" (change)="changeNeedAttention($event)" />
                </div>
              </div>
              </div>
              <div class="row">
                <div class="col-12">
                <label for="customCheck1" translate>lblFixedPrice</label>
                <div class="form-check pl-0">
                  <input type="checkbox" [checked]="isFixed" id="customCheck1" (change)="OnChangeClick($event)" />
                </div>
              </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <label for="customCheck1" translate>lblDisplayPriceInWidget</label>
                  <div class="form-check pl-0">
                    <input type="checkbox" id="customCheck2"  [checked]="displayPriceInWidget"(change)="DisplayPriceInWidget($event)" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label for="customCheck1" translate>lblAdditionalCustomerComment</label>
                  <div class="form-check pl-0">
                    <input type="checkbox" id="customCheck2"  [checked]="isCustomerComment"(change)="OnChangeAdditionalComment($event)" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label for="customCheck1" translate>lblDiagnoseChecklist</label>
                  <div class="form-check pl-0">
                    <input type="checkbox" id="customCheck2"  [checked]="checkListSelected"(change)="OnChangeCheckListSelected($event)" />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col text-right">
                <button type="submit" (click)="onApplyFilter($event)" class="btn btn-primary mr-sm-3" translate>lblApply
                </button>
                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-3" translate>lblReset
                </button>
                <button (click)="onClose()" class="btn btn-outline-tertiary" translate>lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
      <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
        (change)="StatusChange($event)">
        <ng-option *ngFor="let status of StatusList" [value]="status.id">
          {{status.value}}
        </ng-option>
      </ng-select>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6" *ngIf="integrationWithDMS && isDmsSyncService">
      <ng-select placeholder="{{ 'lblDMSStatus' | translate }}" [(ngModel)]="selectedSync"
        (change)="SyncChange($event)">
        <ng-option *ngFor="let status of SyncList" [value]="status.id">
          {{status.value}}
        </ng-option>
      </ng-select>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary "
        translate>lblAddService</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between" translate>
          lblService
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th scope="col" style="width: 55px" translate>#</th>
                <th scope="col" style="width: 8%" sortable="serviceNo" (sort)="onSort($event)" translate>
                  lblServiceNumber</th>
                <th scope="col" style="width: 20%" sortable="name" (sort)="onSort($event)" translate>lblName</th>
                <th scope="col" style="width: 7%" class="text-right" sortable="price" (sort)="onSort($event)" translate>
                  lblPrice
                </th>
                <th scope="col" class="text-right" style="width: 10%" sortable="duration" (sort)="onSort($event)"
                  translate>
                  <span translate>lblDuration</span>
                  (<span translate>lblInMinute</span>)
                </th>
                <th scope="col" style="width: 10%" translate>lblLogo</th>
                <th scope="col" style="width: 12%" sortable="serviceCategoryName" (sort)="onSort($event)" translate>
                  lblCategoryName</th>
                <th scope="col" style="width: 12%" sortable="competenceName" (sort)="onSort($event)" translate>
                  lblCompetenceName</th>
                <th scope="col" class="text-center" translate>lblWidgetSequence</th>
                <th scope="col" class="text-center" translate>lblPlannerSequence</th>
                <th scope="col" class="text-center" translate>lblNeedAttention</th>
                <th scope="col" class="text-center" translate *ngIf="isDmsSyncService" >lblSource</th>
                <th scope="col" style="width:50px" sortable="updatedDate" (sort)="onSort($event)" translate>
                  lblUpdatedDate</th>
                <th scope="col" style="width:50px" sortable="dmsSyncDate" (sort)="onSort($event)" translate
                  *ngIf="integrationWithDMS && isDmsSyncService">lbllastSyncdate</th>
                <th scope="col" style="width: 100px" class="text-center " sortable="isActive" (sort)="onSort($event)"
                  translate>lblActive</th>
                <th scope="col" style="width: 120px" class="text-center " translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="servicesList?.length>0; else load_NotFound_Template">
                <tr *ngFor="let servicesItem of servicesList; let i=index">
                  <td>{{ servicesItem.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="servicesItem.serviceNo">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="servicesItem.name">
                    </ngb-highlight>
                  </td>

                  <td class="text-right">
                    <ngb-highlight [result]="servicesItem.price">
                    </ngb-highlight>
                  </td>

                  <td class="text-right">
                    <ngb-highlight [result]="servicesItem.duration">
                    </ngb-highlight>
                  </td>

                  <td>
                    <img af-image [data-code]="servicesItem.logo" [attr.alt]="servicesItem.name" width="70px" >
                  </td>
                  <td>
                    <ngb-highlight [result]="servicesItem.serviceCategoryName">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="servicesItem.competenceName">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <ngb-highlight [result]="servicesItem.widgetSequence">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <ngb-highlight [result]="servicesItem.plannerSequence">
                    </ngb-highlight>
                  </td>
                  <td class="text-center ">
                    <em class="fas"
                      [ngClass]="{'fa-check': servicesItem.needAttention, 'fa-close': !servicesItem.needAttention}"></em>
                  </td>
                  <td *ngIf="isDmsSyncService" >
                    <ngb-highlight
                      [ngClass]="servicesItem.sourceType ? 'flmid sourceBox rounded-0 justify-content-center' : ''"
                      [result]="servicesItem.sourceType">
                    </ngb-highlight>
                  </td>
                  <td>
                    {{ servicesItem.updatedDate | date:'short'}}
                  </td>
                  <td *ngIf="integrationWithDMS && isDmsSyncService">
                    {{ servicesItem.dmsSyncDate | date:'short'}}
                  </td>
                  <td class="text-center ">
                    <em class="fas"
                      [ngClass]="{'fa-check': servicesItem.isActive, 'fa-times': !servicesItem.isActive}"></em>
                  </td>

                  <td class="nowrap text-center">
                    <ng-container *ngIf="integrationWithDMS && isDmsSyncService">
                      <a class="btn btn-ico" ngbTooltip="{{ 'lblSyncToDMS' | translate }}" tooltipClass="custom-revert"
                        [class.invisible]="servicesItem.dmsSyncStatus != 0" (click)="onSyncToDms(servicesItem.id)">
                        <em class="fas fa-sync fa-lg  "></em>
                      </a>
                      <span class="ico-div" [class.invisible]="servicesItem.dmsSyncStatus != 0"></span>
                      <a class="btn btn-ico" ngbTooltip="{{ 'lblDMSSyncFailedlog' | translate }}"
                        tooltipClass="custom-revert" [class.invisible]="servicesItem.dmsSyncStatus != 0"
                        (click)="viewException(servicesItem.id)">
                        <em class="fas fa-clipboard-list fa-lg  "></em>
                      </a>
                      <span class="ico-div" [class.invisible]="servicesItem.dmsSyncStatus != 0"></span>
                    </ng-container>
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit(servicesItem)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canDelete" (click)="deleteService(servicesItem.id)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>

                  </td>

                </tr>
              </ng-container>
              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>

</div>